import { CategoryApiFacade } from "../category/category.api-facade";
import { JobStatus } from "./job-status.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class JobStatusApiFacade extends CategoryApiFacade<JobStatus> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<JobStatus> {
        return this.GET(`/accounts/${accountId}/jobstatuses/${id}`, options)
            .map(object => new JobStatus(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<JobStatus>> {
        return this.CGET(`/accounts/${accountId}/jobstatuses`, options)
            .map(objects => objects.map(object => new JobStatus(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status/job-status.api-facade.ts